import { render, staticRenderFns } from "./unplan.vue?vue&type=template&id=07c85807&scoped=true"
import script from "./unplan.vue?vue&type=script&lang=js"
export * from "./unplan.vue?vue&type=script&lang=js"
import style0 from "./unplan.vue?vue&type=style&index=0&id=07c85807&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c85807",
  null
  
)

export default component.exports